'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _FieldWrapper = require('../FieldWrapper');

var _FieldWrapper2 = _interopRequireDefault(_FieldWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Amount = function Amount(_ref) {
  var name = _ref.name,
      amountLabel = _ref.amountLabel,
      amountValue = _ref.amountValue,
      currencyValue = _ref.currencyValue,
      normalize = _ref.normalize,
      format = _ref.format,
      validation = _ref.validation,
      onBlur = _ref.onBlur,
      tabIndex = _ref.tabIndex;
  return _react2.default.createElement(_FieldWrapper2.default, {
    name: name,
    type: 'text',
    label: amountLabel,
    value: amountValue,
    normalize: normalize,
    format: format,
    validate: validation,
    onBlur: onBlur,
    tabIndex: tabIndex,
    currency: currencyValue
  });
};

exports.default = Amount;